import type { GameManifest } from "../../contracts/game";

export const marblesManifest: GameManifest = {
  id: "marbles",
  title: "Marbles",
  version: "0.1.0",
  status: "playable",
  coverAsset: "/covers/marbles.jpg",
  catalogOrder: 1,
  preferredAspectRatio: 4 / 3,
  supportsCpu: false,
  load: () => import("./index"),
};
